import * as React from 'react';
import { IconProps } from '../types';

export const PayPalIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 200, ...props }, forwardedRef) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 154.728 190.5" 
        {...props} 
        ref={forwardedRef}><path d="M60.529 38.103a5.49 5.49 0 0 0-5.423 4.633l-9.013 57.15-8.281 52.514-.005.044.01-.044 8.281-52.514a5.486 5.486 0 0 1 5.42-4.633h26.404c26.573 0 49.127-19.387 53.246-45.658.314-1.996.482-3.973.52-5.924v-.003h-.003c-6.753-3.543-14.683-5.565-23.372-5.565z" fill="#001c64"/><path d="M131.686 43.669a44 44 0 0 1-.52 5.926c-4.119 26.271-26.673 45.658-53.246 45.658H51.516a5.486 5.486 0 0 0-5.42 4.633L37.815 152.4l-5.197 32.947a4.46 4.46 0 0 0 4.405 5.153h28.66a5.49 5.49 0 0 0 5.423-4.633l7.55-47.881a5.49 5.49 0 0 1 5.423-4.636h16.876c26.573 0 49.124-19.386 53.243-45.655 2.924-18.649-6.46-35.614-22.511-44.026z" fill="#0070e0"/><path d="M27.967 0a5.49 5.49 0 0 0-5.423 4.636L.055 147.244A4.46 4.46 0 0 0 4.46 152.4h33.351l8.281-52.514 9.013-57.15a5.49 5.49 0 0 1 5.423-4.633h47.782c8.691 0 16.621 2.025 23.375 5.563C132.145 19.749 112.41 0 85.273 0z" fill="#003087"/></svg>
  )
);

PayPalIcon.displayName = 'PayPalIcon';